import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { format, parseISO } from 'date-fns';
import { UserAlert } from '@cigna/chcp/shared/util';

@Component({
  selector: 'cigna-alerts-tasks',
  templateUrl: './alerts-tasks.component.html',
  styleUrl: './alerts-tasks.component.scss',
})
export class AlertsTasksComponent {
  constructor(private router: Router) {}

  @Input() alerts: UserAlert[] = [];

  @Output() startReview = new EventEmitter<UserAlert>();

  isExpanded = false;

  get hasMultipleAlerts(): boolean {
    return this.alerts.length >= 2;
  }

  get visibleAlerts(): UserAlert[] {
    return !this.hasMultipleAlerts || this.isExpanded ? this.alerts : [];
  }

  toggleAlerts(): void {
    this.isExpanded = !this.isExpanded;
  }

  onStartReview(alert: UserAlert): void {
    this.startReview.emit(alert);
    this.isExpanded = false;
    this.router.navigateByUrl(`/my-practice/directory/update/${alert.tin}`);
  }

  getStatus(alert: UserAlert): 'error' | 'warning' {
    return alert.priority === 1 ? 'error' : 'warning';
  }

  getEmphasis(alert: UserAlert): 'strong' | 'subtle' {
    return alert.priority === 1 ? 'strong' : 'subtle';
  }

  getCopyKey(alert: UserAlert, entry: 'heading' | 'body' | 'ctaText'): string {
    return `shared.alertsTasks.${alert.alertType}.${entry}`;
  }

  getCopyParams(alert: UserAlert): Record<string, string | undefined> {
    return {
      tin: alert.tin,
      deadlineDate: alert.expirationDate
        ? format(parseISO(alert.expirationDate), 'MM/dd/yyyy')
        : alert.expirationDate,
    };
  }
}
